import { getStackTrace, log } from '@src/Log.init';
import { rootApi } from './root.api';

export const roleApi = rootApi.injectEndpoints({
  tagTypes: ['Role'],
  endpoints: (builder) => ({
    getPermissions: builder.query({
      query: () => ({
        url: 'permission',
        method: 'GET',
      }),
      providesTags: ['Role'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({ message_type: 'Role', message: 'getPermissions: pending' });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Role',
            message: 'getPermissions: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getPermissions: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getBaseRoles: builder.query({
      query: () => ({
        url: 'baserole',
        method: 'GET',
      }),
      providesTags: ['Role'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({ message_type: 'Role', message: 'getBaseRoles: pending' });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Role',
            message: 'getBaseRoles: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getBaseRoles: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    getRoles: builder.query({
      query: () => ({
        url: 'role',
        method: 'GET',
      }),
      providesTags: ['Role'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({ message_type: 'Role', message: 'getRoles: pending' });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Role',
            message: 'getRoles: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'getRoles: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    createRole: builder.mutation({
      query: (role) => ({
        url: 'role',
        method: 'POST',
        body: role,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Role'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({ message_type: 'Role', message: 'createRole: pending' });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Role',
            message: 'createRole: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'createRole: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    updateRole: builder.mutation({
      query: (role) => ({
        url: 'role',
        method: 'PUT',
        body: role,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Role'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({ message_type: 'Role', message: 'updateRole: pending' });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Role',
            message: 'updateRole: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'updateRole: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
    deleteRole: builder.mutation({
      query: (role) => ({
        url: 'role',
        method: 'DELETE',
        body: role,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Role'],
      async onQueryStarted(arg, { queryFulfilled }) {
        log.debug({ message_type: 'Role', message: 'deleteRole: pending' });
        try {
          const result = await queryFulfilled;
          log.info({
            message_type: 'Role',
            message: 'deleteRole: fulfilled',
            data: result.data,
          });
        } catch (error) {
          log.error({
            message_type: 'SystemError',
            message: 'deleteRole: failure',
            meta_data: getStackTrace(),
            error,
          });
        }
      },
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useLazyGetPermissionsQuery,
  useGetBaseRolesQuery,
  useLazyGetBaseRolesQuery,
  useGetRolesQuery,
  useLazyGetRolesQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = roleApi;
